import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'DOCX_TEMPLATES',
    icon: 'menu-docx-templates',
    label: '模板管理',
    remark: '管理 Word 文档模板，支持合同、物流单等业务场景',
    path: '/docx-template',
  },
] satisfies Menu[];
